module.exports = "/_next/static/resources/cdf-wide-c6f78ce88a73e538e3ee09eb305a4617.webp";